export const def_list = ['26w79f13MWD9SY4', '8FL1XmSRYpFFdDp', '8Lawu3uft1yqvoo', '9crvLGRpoaot8bS', 'EL1LFcG98xodr8E', 'FCsgykz6MiXU6cf', 'I29qSGs4HLhGq51', 'NQ5LkQOKoRmHL2Q', 'QGEhiovl1FLQHCJ', 'TdnzOi64j4Zfcl5', 'VF27nr11jIT4bUG', 'Y2Ic6VrQhavKQCr', 'YO3JIU8EfCCoXnC', 'YhphyrXvXZgjfyK', 'dnk2ikYvgxEPNv2', 'e6ebR4z3srJFwDR', 'ggI2C5MxapcNdPz', 'hISSQXPN06cahWh', 'i66tJi7juxTM9ZO', 'ioc8nzpuzoXo06H', 'oS73bhTZk5uPoAd', 't8B4HzRz2F0Wn2J', 'tBaQcmEZBOPRbf8', 'tvFzEYD23nTeDx3', 'ucXAI4YMcX5iHYL']

export const def = {
    "flows": [
        {
            "id": "3BsjnGpW9n",
            "in": "26w79f13MWD9SY4",
            "inPort": 1,
            "out": "I29qSGs4HLhGq51",
            "outPort": 0
        },
        {
            "id": "CoaToxpngq",
            "in": "Y2Ic6VrQhavKQCr",
            "inPort": 0,
            "out": "26w79f13MWD9SY4",
            "outPort": 0
        },
        {
            "id": "DCUi0bIHd0",
            "in": "dnk2ikYvgxEPNv2",
            "inPort": 0,
            "out": "e6ebR4z3srJFwDR",
            "outPort": 0
        },
        {
            "id": "LpbsTF8k9U",
            "in": "8FL1XmSRYpFFdDp",
            "inPort": 0,
            "out": "Y2Ic6VrQhavKQCr",
            "outPort": 0
        },
        {
            "id": "ZQ5aS9MtRG",
            "in": "dnk2ikYvgxEPNv2",
            "inPort": 1,
            "out": "ioc8nzpuzoXo06H",
            "outPort": 0
        },
        {
            "id": "jC4aQHsNIp",
            "in": "26w79f13MWD9SY4",
            "inPort": 3,
            "out": "oS73bhTZk5uPoAd",
            "outPort": 0
        },
        {
            "id": "luOton2LXy",
            "in": "I29qSGs4HLhGq51",
            "inPort": 0,
            "out": "dnk2ikYvgxEPNv2",
            "outPort": 0
        },
        {
            "id": "ow8R6yigeF",
            "in": "26w79f13MWD9SY4",
            "inPort": 0,
            "out": "YhphyrXvXZgjfyK",
            "outPort": 0
        },
        {
            "id": "t0qqDdlYZr",
            "in": "oS73bhTZk5uPoAd",
            "inPort": 0,
            "out": "dnk2ikYvgxEPNv2",
            "outPort": 0
        },
        {
            "id": "wO1v5kFGKR",
            "in": "26w79f13MWD9SY4",
            "inPort": 2,
            "out": "hISSQXPN06cahWh",
            "outPort": 0
        }
    ],
    "datas": [
        {
            "id": "26w79f13MWD9SY4",
            "subname": "processorArray",
            "name": "Array Processor",
            "ports": {
                "in": [
                    true,
                    true,
                    true,
                    true
                ],
                "out": []
            },
            "count": 4,
            "array": [
                "Length of \"",
                "Input A-Input B",
                "\" is:",
                null
            ]
        },
        {
            "id": "8FL1XmSRYpFFdDp",
            "subname": "blockText",
            "name": "Output",
            "ports": {
                "in": [
                    true
                ],
                "out": []
            },
            "maxWidth": 267,
            "text": "Length of \"Input A-Input B\" is:"
        },
        {
            "id": "8Lawu3uft1yqvoo",
            "subname": "sketchImage",
            "name": "New Image",
            "ports": {
                "in": [],
                "out": []
            },
            "source": {
                "type": "url",
                "sourceStr": "https://dl.memuplay.com/new_market/img/com.PlayCastle.popcat.icon.2021-08-22-10-26-37.png"
            },
            "dim": {
                "resizeMode": {
                    "none": false,
                    "both": true,
                    "h": false,
                    "v": false
                },
                "width": 195.33333333333334,
                "height": 197.83333333333334
            },
            "radius": 0,
            "flip": {
                "h": false,
                "v": false
            }
        },
        {
            "id": "9crvLGRpoaot8bS",
            "subname": "sketchIcon",
            "name": "New Icon",
            "ports": {
                "in": [],
                "out": []
            },
            "icon": "AiFillAndroid",
            "size": 45,
            "color": "white"
        },
        {
            "id": "EL1LFcG98xodr8E",
            "subname": "sketchText",
            "name": "New Text",
            "ports": {
                "in": [],
                "out": []
            },
            "text": "Use Your Right Button to Add Objects",
            "maxWidth": 0,
            "size": 33,
            "color": {
                "background": "#00000000",
                "foreground": "#FFFFFF"
            },
            "font": "Times New Roman",
            "style": {
                "bold": true,
                "italic": true
            },
            "line": {
                "over": false,
                "through": false,
                "under": true
            },
            "permanent": false,
            "align": {
                "left": true,
                "center": false,
                "justify": false,
                "right": false
            }
        },
        {
            "id": "FCsgykz6MiXU6cf",
            "subname": "sketchIcon",
            "name": "New Icon",
            "ports": {
                "in": [],
                "out": []
            },
            "icon": "MdPerson",
            "size": 45,
            "color": "white"
        },
        {
            "id": "I29qSGs4HLhGq51",
            "subname": "blockText",
            "name": "New Block Text",
            "ports": {
                "in": [
                    true
                ],
                "out": []
            },
            "maxWidth": 180,
            "text": "Input A-Input B"
        },
        {
            "id": "NQ5LkQOKoRmHL2Q",
            "subname": "sketchText",
            "name": "New Text",
            "ports": {
                "in": [],
                "out": []
            },
            "text": "Logic Blocks",
            "maxWidth": 0,
            "size": 46,
            "color": {
                "background": "#00000000",
                "foreground": "#FFFFFF"
            },
            "font": "Arial",
            "style": {
                "bold": false,
                "italic": false
            },
            "line": {
                "over": false,
                "through": false,
                "under": false
            },
            "permanent": true,
            "align": {
                "left": true,
                "center": false,
                "justify": false,
                "right": false
            }
        },
        {
            "id": "QGEhiovl1FLQHCJ",
            "subname": "sketchIcon",
            "name": "AiFillRightCircle",
            "ports": {
                "in": [],
                "out": []
            },
            "icon": "AiFillRightCircle",
            "size": 45,
            "color": "#45caecff"
        },
        {
            "id": "TdnzOi64j4Zfcl5",
            "subname": "sketchText",
            "name": "New Text",
            "ports": {
                "in": [],
                "out": []
            },
            "text": "Welcome to Plain Notebook",
            "maxWidth": 0,
            "size": 82,
            "color": {
                "background": "#00000000",
                "foreground": "#FFFFFF"
            },
            "font": "Tahoma",
            "style": {
                "bold": true,
                "italic": false
            },
            "line": {
                "over": false,
                "through": false,
                "under": false
            },
            "permanent": true,
            "align": {
                "left": true,
                "center": false,
                "justify": false,
                "right": false
            }
        },
        {
            "id": "VF27nr11jIT4bUG",
            "subname": "blockRTF",
            "name": "New Block RTF",
            "ports": {
                "in": [],
                "out": []
            },
            "maxWidth": 500,
            "content": "<p><strong class=\"ql-size-huge\">Welcome to Plain Notebook</strong></p><p><strong class=\"ql-size-large\"><u>Use Your Right Button to Add Objects</u></strong></p><p><strong class=\"ql-size-large\">By the way, this is a RTF block</strong></p>",
            "size": 12
        },
        {
            "id": "Y2Ic6VrQhavKQCr",
            "subname": "processorJoin",
            "name": "Join Processor",
            "ports": {
                "in": [
                    true
                ],
                "out": []
            },
            "delimiter": "",
            "array": [
                "Length of \"",
                "Input A-Input B",
                "\" is:",
                null
            ]
        },
        {
            "id": "YO3JIU8EfCCoXnC",
            "subname": "sketchIcon",
            "name": "New Icon",
            "ports": {
                "in": [],
                "out": []
            },
            "icon": "MdEmojiEmotions",
            "size": 77,
            "color": "white"
        },
        {
            "id": "YhphyrXvXZgjfyK",
            "subname": "blockText",
            "name": "New Block Text",
            "ports": {
                "in": [
                    false
                ],
                "out": []
            },
            "maxWidth": 180,
            "text": "Length of \""
        },
        {
            "id": "dnk2ikYvgxEPNv2",
            "subname": "processorConcat",
            "name": "Concat Processor",
            "ports": {
                "in": [
                    true,
                    true
                ],
                "out": []
            },
            "text1": "Input A",
            "text2": "Input B",
            "delimiter": "-"
        },
        {
            "id": "e6ebR4z3srJFwDR",
            "subname": "blockText",
            "name": "New Block Text",
            "ports": {
                "in": [],
                "out": []
            },
            "maxWidth": 180,
            "text": "Input A"
        },
        {
            "id": "ggI2C5MxapcNdPz",
            "subname": "sketchText",
            "name": "New Text",
            "ports": {
                "in": [],
                "out": []
            },
            "text": "You can use it as a sample sketchbook",
            "maxWidth": 0,
            "size": 28,
            "color": {
                "background": "#00000000",
                "foreground": "#FFFFFF"
            },
            "font": "Arial",
            "style": {
                "bold": false,
                "italic": false
            },
            "line": {
                "over": false,
                "through": false,
                "under": false
            },
            "permanent": true,
            "align": {
                "left": true,
                "center": false,
                "justify": false,
                "right": false
            }
        },
        {
            "id": "hISSQXPN06cahWh",
            "subname": "blockText",
            "name": "New Block Text",
            "ports": {
                "in": [],
                "out": []
            },
            "maxWidth": 180,
            "text": "\" is:"
        },
        {
            "id": "i66tJi7juxTM9ZO",
            "subname": "sketchLink",
            "name": "New Link",
            "ports": {
                "in": [],
                "out": []
            },
            "link": "https://lyonlu13.github.io/plan-board/",
            "size": 12,
            "simple": false,
            "image": true,
            "description": true
        },
        {
            "id": "ioc8nzpuzoXo06H",
            "subname": "blockText",
            "name": "New Block Text",
            "ports": {
                "in": [],
                "out": []
            },
            "maxWidth": 180,
            "text": "Input B"
        },
        {
            "id": "oS73bhTZk5uPoAd",
            "subname": "processorTextCount",
            "name": "Text Count Processor",
            "ports": {
                "in": [
                    true
                ],
                "out": []
            },
            "text": "\"Input A-Input B\""
        },
        {
            "id": "t8B4HzRz2F0Wn2J",
            "subname": "sketchText",
            "name": "New Text",
            "ports": {
                "in": [],
                "out": []
            },
            "text": "Sketch Objects",
            "maxWidth": 0,
            "size": 46,
            "color": {
                "background": "#00000000",
                "foreground": "#FFFFFF"
            },
            "font": "Arial",
            "style": {
                "bold": false,
                "italic": false
            },
            "line": {
                "over": false,
                "through": false,
                "under": false
            },
            "permanent": true,
            "align": {
                "left": true,
                "center": false,
                "justify": false,
                "right": false
            }
        },
        {
            "id": "tBaQcmEZBOPRbf8",
            "subname": "sketchText",
            "name": "New Text",
            "ports": {
                "in": [],
                "out": []
            },
            "text": "Or do some easy computation",
            "maxWidth": 0,
            "size": 28,
            "color": {
                "background": "#00000000",
                "foreground": "#FFFFFF"
            },
            "font": "Arial",
            "style": {
                "bold": false,
                "italic": false
            },
            "line": {
                "over": false,
                "through": false,
                "under": false
            },
            "permanent": true,
            "align": {
                "left": true,
                "center": false,
                "justify": false,
                "right": false
            }
        },
        {
            "id": "tvFzEYD23nTeDx3",
            "subname": "sketchIcon",
            "name": "New Icon",
            "ports": {
                "in": [],
                "out": []
            },
            "icon": "AiFillBook",
            "size": 45,
            "color": "white"
        },
        {
            "id": "ucXAI4YMcX5iHYL",
            "subname": "sketchIcon",
            "name": "New Icon",
            "ports": {
                "in": [],
                "out": []
            },
            "icon": "AiFillCar",
            "size": 45,
            "color": "white"
        }
    ],
    "objects": [
        {
            "id": "26w79f13MWD9SY4",
            "pos": {
                "x": 390.285714285714,
                "y": 389.85714285714295
            },
            "type": 2,
            "subname": "ProcessorArray",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "8FL1XmSRYpFFdDp",
            "pos": {
                "x": 685.9999999999997,
                "y": 387.0000000000001
            },
            "type": 1,
            "subname": "BlockText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "8Lawu3uft1yqvoo",
            "pos": {
                "x": -395.5988455988446,
                "y": -96.46031746031731
            },
            "type": 0,
            "subname": "SketchImage",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "9crvLGRpoaot8bS",
            "pos": {
                "x": -29.884559884558904,
                "y": -36.46031746031732
            },
            "type": 0,
            "subname": "SketchIcon",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "EL1LFcG98xodr8E",
            "pos": {
                "x": -334.17027417027316,
                "y": -383.6031746031744
            },
            "type": 0,
            "subname": "SketchText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "FCsgykz6MiXU6cf",
            "pos": {
                "x": -191.31313131313033,
                "y": -36.46031746031732
            },
            "type": 0,
            "subname": "SketchIcon",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "I29qSGs4HLhGq51",
            "pos": {
                "x": 144.5714285714283,
                "y": 318.4285714285715
            },
            "type": 1,
            "subname": "BlockText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "NQ5LkQOKoRmHL2Q",
            "pos": {
                "x": -392.5714285714288,
                "y": 207.0000000000001
            },
            "type": 0,
            "subname": "SketchText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "QGEhiovl1FLQHCJ",
            "pos": {
                "x": -381.3131313131303,
                "y": -383.6031746031744
            },
            "type": 0,
            "subname": "SketchIcon",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "TdnzOi64j4Zfcl5",
            "pos": {
                "x": -390.0155122655119,
                "y": -487.56529581529577
            },
            "type": 0,
            "subname": "SketchText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "VF27nr11jIT4bUG",
            "pos": {
                "x": 293.1428571428569,
                "y": -191.5714285714284
            },
            "type": 1,
            "subname": "BlockRTF",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "Y2Ic6VrQhavKQCr",
            "pos": {
                "x": 525.9999999999997,
                "y": 582.7142857142858
            },
            "type": 2,
            "subname": "ProcessorJoin",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "YO3JIU8EfCCoXnC",
            "pos": {
                "x": 777.1273448773451,
                "y": -467.56529581529577
            },
            "type": 0,
            "subname": "SketchIcon",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "YhphyrXvXZgjfyK",
            "pos": {
                "x": 143.14285714285688,
                "y": 201.2857142857144
            },
            "type": 1,
            "subname": "BlockText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "dnk2ikYvgxEPNv2",
            "pos": {
                "x": -174.00000000000026,
                "y": 482.7142857142858
            },
            "type": 2,
            "subname": "ProcessorConcat",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "e6ebR4z3srJFwDR",
            "pos": {
                "x": -418.2857142857145,
                "y": 484.1428571428572
            },
            "type": 1,
            "subname": "BlockText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "ggI2C5MxapcNdPz",
            "pos": {
                "x": -379.8845598845589,
                "y": -152.17460317460302
            },
            "type": 0,
            "subname": "SketchText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "hISSQXPN06cahWh",
            "pos": {
                "x": 147.42857142857116,
                "y": 429.85714285714295
            },
            "type": 1,
            "subname": "BlockText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "i66tJi7juxTM9ZO",
            "pos": {
                "x": -194.17027417027316,
                "y": -96.46031746031731
            },
            "type": 0,
            "subname": "SketchLink",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "ioc8nzpuzoXo06H",
            "pos": {
                "x": -419.71428571428595,
                "y": 595.5714285714287
            },
            "type": 1,
            "subname": "BlockText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "oS73bhTZk5uPoAd",
            "pos": {
                "x": 123.14285714285687,
                "y": 574.1428571428572
            },
            "type": 2,
            "subname": "ProcessorTextCount",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "t8B4HzRz2F0Wn2J",
            "pos": {
                "x": -384.17027417027316,
                "y": -217.88888888888874
            },
            "type": 0,
            "subname": "SketchText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "tBaQcmEZBOPRbf8",
            "pos": {
                "x": -395.4285714285717,
                "y": 287.0000000000001
            },
            "type": 0,
            "subname": "SketchText",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "tvFzEYD23nTeDx3",
            "pos": {
                "x": -87.02741702741604,
                "y": -36.46031746031732
            },
            "type": 0,
            "subname": "SketchIcon",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        },
        {
            "id": "ucXAI4YMcX5iHYL",
            "pos": {
                "x": -141.31313131313033,
                "y": -37.88888888888875
            },
            "type": 0,
            "subname": "SketchIcon",
            "locked": false,
            "visibility": true,
            "position": "absolute",
            "container": ""
        }
    ]
}